import React from 'react';
import icon from '../assets/icon.png';
import { Buttons } from '../components/Buttons';
import email from '../assets/icons/email.png';
import call from '../assets/icons/call.png';
import location from '../assets/icons/location.png';
import { submitContactEmail } from '../contact';

const contactInfo = [
  {
    img: location,
    label: 'Address',
    value: '2480 Mission Street Suite 108, \n San Francisco, CA 94110',
  },
  {
    img: email,
    label: 'Email',
    value: 'contact@millenniumrealtysf.com',
  },
  {
    img: call,
    label: 'Phone',
    value: '415-610-7765',
  },
];

const Contact = () => {
  return (
    <div className="w-full bg-black">

      {/* Hero */}
      <div className="w-full bg-[#1A1A1A] px-[4rem] py-[5rem] flex flex-col items-center gap-[1rem] text-center border-b border-[#262626]">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">We're Here to Help You Manage Your Property</p>
        </div>
        <h1 className="text-[55px] leading-tight font-bold text-gradient">Get In Touch</h1>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Whether you own a single rental home or a commercial property portfolio in the San Francisco & Bay Area, our licensed and experienced team is ready to provide expert property management solutions. Contact us today to discuss your goals, schedule a consultation, or request more information about our services.
        </p>
      </div>

      {/* Contact Grid */}
      <div className="w-full px-[4rem] py-[5rem] flex flex-wrap gap-[4rem] justify-center max-w-[1440px] mx-auto">

        {/* Contact Info */}
        <div className="flex-1 min-w-[280px] max-w-[420px] flex flex-col gap-[2rem]">
          <div className="flex flex-col gap-[1rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Reach Us</p>
            </div>
            <h2 className="text-[38px] font-bold text-gradient">Contact Information</h2>
            <p className="text-white text-[17px] font-light">
              Have questions? We'd love to hear from you. Our team is available during business hours to assist with your property management and real estate needs.
            </p>
          </div>
          <div className="flex flex-col gap-[1.5rem]">
            {contactInfo.map((info, i) => (
              <div key={i} className="flex items-start gap-[1rem] bg-[#1A1A1A] border border-[#262626] rounded-lg p-[1.5rem] hover:border-[#EEC24B] transition-all duration-300">
                <img src={info.img} alt="" className="w-[28px] h-[28px] object-contain mt-1 flex-shrink-0" />
                <div>
                  <p className="text-[#EEC24B] text-[14px] font-semibold uppercase tracking-wider mb-[0.3rem]">{info.label}</p>
                  <p className="text-white text-[17px] font-light whitespace-pre-line">{info.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Form */}
        <div className="flex-1 min-w-[280px] max-w-[680px]">
          <div className="flex flex-col gap-[1rem] mb-[2rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Send a Message</p>
            </div>
            <h2 className="text-[38px] font-bold text-gradient">Let's Start a Conversation</h2>
          </div>

          <form className="flex flex-col gap-[1.5rem]" onSubmit={(event) => submitContactEmail(event, 'Property services inquiry')}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5rem]">
              {[
                { label: 'First Name', name: 'firstName', autoComplete: 'given-name' },
                { label: 'Last Name', name: 'lastName', autoComplete: 'family-name' },
                { label: 'Email Address', name: 'email', autoComplete: 'email' },
                { label: 'Phone Number', name: 'phone', autoComplete: 'tel' },
              ].map((field) => (
                <div key={field.name} className="flex flex-col gap-[0.5rem]">
                  <label htmlFor={`contact-${field.name}`} className="text-[18px] text-gradient font-bold">{field.label}</label>
                  <input
                    id={`contact-${field.name}`}
                    name={field.name}
                    type={field.name === 'email' ? 'email' : field.name === 'phone' ? 'tel' : 'text'}
                    autoComplete={field.autoComplete}
                    required={field.name !== 'phone'}
                    placeholder={`Enter your ${field.label.toLowerCase()}...`}
                    className="w-full p-[0.9rem] rounded-lg border border-[#262626] bg-[#1A1A1A] text-white placeholder-[#666] focus:outline-none focus:border-[#EEC24B] transition-all"
                  />
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-[0.5rem]">
              <label htmlFor="contact-service" className="text-[18px] text-gradient font-bold">Service Needed</label>
              <select id="contact-service" name="service" required className="w-full p-[0.9rem] rounded-lg border border-[#262626] bg-[#1A1A1A] text-[#BDBDBD] focus:outline-none focus:border-[#EEC24B] transition-all">
                <option value="">Select a service...</option>
                <option value="property-management">Property Management</option>
                <option value="rent">For Rent / Lease</option>
                <option value="office">Office Listing</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="flex flex-col gap-[0.5rem]">
              <label htmlFor="contact-message" className="text-[18px] text-gradient font-bold">Message</label>
              <textarea
                id="contact-message"
                name="message"
                required
                rows="5"
                placeholder="Enter your message..."
                className="w-full p-[0.9rem] rounded-lg border border-[#262626] bg-[#1A1A1A] text-white placeholder-[#666] focus:outline-none focus:border-[#EEC24B] transition-all resize-none"
              />
            </div>

            <div>
              <Buttons title="Send Message" width="200px" type="submit" />
            </div>
          </form>
        </div>

      </div>

      {/* Map Section */}
      <div className="w-full px-[4rem] py-[3rem] bg-[#1A1A1A] border-t border-[#262626] flex flex-col gap-[2rem] items-center">
        <div className="flex flex-col items-center gap-[0.5rem] text-center">
          <div className="flex gap-[5px] justify-center">
            <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
            <p className="text-[18px] text-white">Our Location</p>
          </div>
          <h2 className="text-[38px] font-bold text-gradient">Find Us Here</h2>
        </div>
        <div className="w-full max-w-[1000px] rounded-lg overflow-hidden border border-[#262626]">
          <iframe
            title="Millennium Realty Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.3563742958706!2d-122.42247248468185!3d37.75530337975917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7e3b0a4b9e7d%3A0x1234567890abcdef!2s2480%20Mission%20St%20Suite%20108%2C%20San%20Francisco%2C%20CA%2094110!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

    </div>
  );
};

export default Contact;
